import React from 'react';
import MainContext from '../../contexts/MainContext';
import { BetslipContext } from '../../data/betslip/BetslipConf';
import { getLabel } from '../../InitData';
import FastbetAmount from './FastbetAmount';

function FastbetPopup(props) {
    const mainContext = React.useContext(MainContext);
    const betslipContext = React.useContext(BetslipContext);

    const fastbetEnabled = betslipContext.isAddAndBetEnabled();

    return (
        <div className="customPopup">
            <div className="customPopup__content">
                <div className="customPopup__content__header">
                    <div className="customPopup__content__header__title">
                        <p className="bianco">{fastbetEnabled ? getLabel('live.fastbet_popup.change_amount') : getLabel('live.fastbet_popup.title')}</p>
                    </div>
                    <button className="customPopup__content__header__closeButton" onClick={mainContext.toggleFastbetPopup.bind(mainContext)}>
                        <i className="fas fa-times"></i>
                    </button>
                </div>
                <div className="customPopup__content__body">
                    {fastbetEnabled ?
                        <FastbetAmount />
                        :
                        <>
                            <p>{getLabel('live.fastbet_popup.message')}</p>
                            <hr />
                            <FastbetAmount />
                        </>
                    }
                </div>
            </div>
        </div>
    );
}

export default FastbetPopup;